import SectionHeading from "@/components/base/SectionHeading";
import { processSteps } from "@/mocks/home";

export default function ProcessSection() {
  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-screen-2xl px-4 md:px-6">
        <SectionHeading
          eyebrow="How It Works"
          title="Simple, Transparent Moving Process"
          subtitle="Four easy steps from your first enquiry to a fully unpacked home or office."
        />

        <div className="relative mt-12 grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
          {processSteps.map((step, index) => (
            <div key={step.title} className="relative flex flex-col items-center text-center">
              <span className="relative flex h-16 w-16 items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className={`${step.icon} text-3xl`} />
                <span className="absolute -right-2 -top-2 flex h-7 w-7 items-center justify-center rounded-full bg-foreground-950 text-xs font-bold text-background-50">
                  {index + 1}
                </span>
              </span>
              <h3 className="mt-5 font-heading text-base font-semibold text-foreground-950 md:text-lg">
                {step.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{step.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}